import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';

import { Image } from '../../foundations/Image/Image';
import { buildImageSizes } from '../../foundations/Image/utils/buildImageSizes';
import { buildImageSrcSet } from '../../foundations/Image/utils/buildImageSrcSet';
// TODO: replace with ribbons ProductCard import when available
import { CarouselProductCard } from '../Cards/CarouselProductCard/components/CarouselProductCard';
import type { PartnerProfileProps } from './types';
import * as styles from './PartnerProfile.styles';

export const PartnerProfile = ({
  copy,
  cta,
  currency,
  heading,
  imageHeight,
  imageWidth,
  images,
  lazyImages,
  onPartnerClick,
  onProductClick,
  onVisible = () => {},
  products,
  url,
}: PartnerProfileProps) => {
  const productsRef = useImpressionRef<HTMLDivElement>(() => onVisible());

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    onPartnerClick?.(e);
  };

  return (
    <div css={styles.partner}>
      <div css={styles.partnerImageContainer}>
        <Image
          css={styles.partnerImage}
          height={imageHeight}
          loading={lazyImages ? 'lazy' : 'eager'}
          sizes={buildImageSizes({ XXS: '75vw', M: '33vw', L: '25vw', XL: '330px' })}
          src={images[0]?.src}
          srcSet={buildImageSrcSet(images.map(({ src, width }) => ({ src, width, unit: 'w' })))}
          width={imageWidth}
        />
      </div>
      <div css={styles.partnerCopyContainer}>
        <div css={styles.partnerCopyContent}>
          <h3 css={styles.partnerHeading}>{heading}</h3>
          <p css={styles.partnerCopy}>{copy}</p>
          <a css={styles.partnerCta} href={url} onClick={handleClick}>
            {cta}
          </a>
        </div>
      </div>
      <div css={styles.productsContainer} ref={productsRef}>
        {products.length > 0 &&
          products.map((product, productIndex) => (
            <div css={styles.product} key={product.title}>
              <CarouselProductCard
                {...product}
                currency={currency}
                imageLoading={lazyImages ? 'lazy' : 'eager'}
                onLinkClick={(e) => onProductClick?.(e, { productIndex })}
                size="auto"
              />
            </div>
          ))}
      </div>
    </div>
  );
};
